

export class GpsDeviceSelectByCompanyAndBranchDetailsIdOutputData implements IGpsDeviceSelectByCompanyAndBranchDetailsIdOutputData {
    /** The auto-generated id of the GPS device master */
    gps_device_id!: number;
    /** The employee first name with 50 character limit */
    device_name!: string;

    constructor(data?: IGpsDeviceSelectByCompanyAndBranchDetailsIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gps_device_id = _data["gps_device_id"];
            this.device_name = _data["device_name"];
        }
    }

    static fromJS(data: any): GpsDeviceSelectByCompanyAndBranchDetailsIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new GpsDeviceSelectByCompanyAndBranchDetailsIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gps_device_id"] = this.gps_device_id;
        data["device_name"] = this.device_name;
        return data; 
    }
}

export interface IGpsDeviceSelectByCompanyAndBranchDetailsIdOutputData {
    /** The auto-generated id of the GPS device master */
    gps_device_id: number;
    /** The employee first name with 50 character limit */
    device_name: string;
}

